import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import "trix"
import "@rails/actiontext"
import "./routes"
import "leaflet"
import "leaflet-polylinedecorator"
import { DotLottie } from "@lottiefiles/dotlottie-web"

// Make DotLottie available globally
window.DotLottie = DotLottie
